var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notification)?_c('div',{class:["notification flex fw9 f4 lh-title z-10 tc flex justify-center",{error: _vm.isError}, _vm.$css(_vm.styles.notification)]},[_vm._v(" "+_vm._s(_vm.notification.text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }